import { Box, styled } from '@mui/material';

export const StatsTileSection = styled(Box, {
  shouldForwardProp: prop => prop !== 'tileHeight',
})<{ tileHeight?: string }>(({ tileHeight = '245px' }) => ({
  width: '432px',
  height: tileHeight,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  overflow: 'hidden',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
}));

export const StatsTileHeader = styled(Box, {
  shouldForwardProp: prop => prop !== 'headerBackground' && prop !== 'headerTextColor',
})<{ headerBackground?: string; headerTextColor?: string }>(
  ({ headerBackground = '#71B790', headerTextColor = '#FFFFFF' }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '14px 16px',
    backgroundColor: headerBackground,
    color: headerTextColor,
  }),
);

export const StatsTileTitle = styled('span')(() => ({
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
}));

export const StatsTileBody = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'stretch',
}));

export const StatColumn = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '16px',
  gap: '8px',
}));

export const StatDivider = styled(Box)(() => ({
  width: '1px',
  height: '104px',
  backgroundColor: '#E7E8E8',
  alignSelf: 'center',
  flexShrink: 0,
}));

export const StatLabel = styled('span', {
  shouldForwardProp: prop => prop !== 'labelColor',
})<{ labelColor?: string }>(({ labelColor = '#9EA2A2' }) => ({
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  color: labelColor,
  textAlign: 'center',
}));

export const StatValue = styled('span', {
  shouldForwardProp: prop => prop !== 'valueColor',
})<{ valueColor?: string }>(({ valueColor = '#008C15' }) => ({
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
  fontSize: '40px',
  lineHeight: '48px',
  color: valueColor,
}));

export const StatsTileFooter = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 16px 12px',
}));
